import CookieBanner from '@/components/CookieBanner'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		data: {},
		...opts,
		vueComponent: CookieBanner
	}

	let page = vuewidget(dom, options)
	return page
}